/* Product gallery zoom: PhotoSwipe lightbox opened by the magnifier button.
   The library loads on the first click only. Slides are read from the live
   slider at open time, so a colour switch or a metafield gallery can never
   hand the lightbox the previous variant's photos. */
(function () {
  'use strict';

  var ZOOM_WIDTH = 1730; // same render size the reference site serves
  var corePromise = null;

  function loadCore(url) {
    if (corePromise) return corePromise;
    corePromise = new Promise(function (resolve, reject) {
      if (window.PhotoSwipe) return resolve(window.PhotoSwipe);
      var s = document.createElement('script');
      s.src = url;
      s.onload = function () { resolve(window.PhotoSwipe); };
      s.onerror = reject;
      document.head.appendChild(s);
    });
    return corePromise;
  }

  function sizedUrl(src, width) {
    if (!src) return src;
    if (/[?&]width=\d+/.test(src)) return src.replace(/([?&]width=)\d+/, '$1' + width);
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function slidesFrom(sliderElement) {
    var slides = Array.prototype.slice.call(
      sliderElement.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)')
    );
    var items = [];
    slides.forEach(function (slide, slideIndex) {
      // Video slides have a poster <img> inside the <video> fallback, but the
      // lightbox is for stills: opening a video in PhotoSwipe would show its
      // poster and pause the inline player for nothing.
      if (
        slide.dataset.mediaType === 'video' ||
        slide.querySelector('[data-product-gallery-video]')
      ) {
        return;
      }
      var img = slide.querySelector('img');
      if (!img) return;
      var src = img.currentSrc || img.getAttribute('src');
      if (!src) return;
      var natW = img.naturalWidth || parseInt(img.getAttribute('width'), 10) || 1000;
      var natH = img.naturalHeight || parseInt(img.getAttribute('height'), 10) || 1500;
      items.push({
        slideIndex: slideIndex,
        src: sizedUrl(src, ZOOM_WIDTH),
        width: ZOOM_WIDTH,
        height: Math.round((ZOOM_WIDTH * natH) / natW),
        alt: img.getAttribute('alt') || ''
      });
    });
    return items;
  }

  // pswp.ui only exists after init - uiRegister is the documented hook
  function addDots(pswp, total) {
    if (total < 2) return;
    pswp.on('uiRegister', function () {
    pswp.ui.registerElement({
      name: 'pswp-dots',
      appendTo: 'wrapper',
      onInit: function (el) {
        el.className = 'pswp__dots';
        for (var i = 0; i < total; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'pswp__dot';
          dot.setAttribute('aria-label', String(i + 1));
          dot.dataset.index = String(i);
          el.appendChild(dot);
        }
        el.addEventListener('click', function (event) {
          var dot = event.target.closest('.pswp__dot');
          if (dot) pswp.goTo(parseInt(dot.dataset.index, 10));
        });
        var sync = function () {
          Array.prototype.forEach.call(el.children, function (dot, i) {
            dot.classList.toggle('pswp__dot--active', i === pswp.currIndex);
          });
        };
        pswp.on('change', sync);
        sync();
      }
    });
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-product-zoom-button]');
    if (!button) return;

    var root = button.closest('[data-product-media-gallery-slider]');
    var sliderElement = root && root.querySelector('[data-product-media-main-slider]');
    if (!sliderElement) return;

    var items = slidesFrom(sliderElement);
    if (!items.length) return;

    var swiper = sliderElement.swiper;
    var activeSlideIndex = swiper ? swiper.activeIndex : 0;
    var index = -1;
    items.forEach(function (item, itemIndex) {
      if (item.slideIndex === activeSlideIndex) index = itemIndex;
    });
    // The active slide is a video (or has no still to zoom): the zoom trigger
    // is hidden by pm-custom.js, but a stale click must not open the wrong
    // image at the wrong position either.
    if (index === -1) return;

    loadCore(button.dataset.pswpCore).then(function (PhotoSwipe) {
      if (!PhotoSwipe) return;
      var pswp = new PhotoSwipe({
        dataSource: items,
        index: index,
        bgOpacity: 1,
        showHideAnimationType: 'fade',
        wheelToZoom: true,
        counter: false,
        zoom: false,          // no zoom button: wheel, pinch and double tap only
        close: true,
        arrowPrev: items.length > 1,
        arrowNext: items.length > 1,
        padding: { top: 60, bottom: 60, left: 0, right: 0 },
        // Reference-store icons: thin 1.2 strokes, no PhotoSwipe default chrome.
        closeSVG: '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><path d="M13 13L1 1M13 1L1 13" stroke="currentColor" stroke-width="1.2" fill="none"/></svg>',
        arrowPrevSVG: '<svg width="17" height="14" viewBox="0 0 17 14" aria-hidden="true"><path d="M17 7H2M8 1L2 7l6 6" stroke="currentColor" stroke-width="1.2" fill="none"/></svg>',
        arrowNextSVG: '<svg width="17" height="14" viewBox="0 0 17 14" aria-hidden="true"><path d="M0 7h15M9 1l6 6-6 6" stroke="currentColor" stroke-width="1.2" fill="none"/></svg>'
      });
      addDots(pswp, items.length);
      pswp.init();
    });
  });
})();
